import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-49869924"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Detalles del Libro")
], -1))
const _hoisted_3 = { class: "Tbody" }
const _hoisted_4 = { class: "img-book" }
const _hoisted_5 = ["src", "width", "height"]
const _hoisted_6 = { class: "details" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Título", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Autor", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Categoría", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Editorial", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Año", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Descripción", -1))
const _hoisted_13 = { class: "buttons" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["href"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn-download" }, "Descargar versión EPUB", -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer-btn" }, null, -1))
const _hoisted_19 = { key: 1 }
const _hoisted_20 = ["href"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn-download" }, "Descargar versión PDF", -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer-btn" }, null, -1))
const _hoisted_24 = { key: 2 }
const _hoisted_25 = ["href"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn-download" }, "Comprar en formato físico", -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { key: 0 }

import DefaultLayout from '@/layouts/DefaultLayout.vue';
import BookInterface from '@/interfaces/BookInterface';
import { Ref,ref,onMounted } from 'vue';
import BookService from '@/services/BookService';
import { useRoute } from 'vue-router';
import main from '@/data/main.js';

export default /*#__PURE__*/_defineComponent({
  __name: 'BookShopDetailView',
  setup(__props) {

const loading = ref(false)
const route = useRoute()


const widthIMG:Ref<number> = ref(600)
const heightIMG:Ref<number> = ref(400)

const book:Ref<BookInterface> = ref({
    id: 0,
    title: '',
    author:'',
    publisher:'',
    category:'',
    pdf_uri: '',
    epub_uri:'',
    paper_purchase_uri:'',
    order:0,
    description: '',
    image_uri: '',
    created_at:'',
    updated_at:''  
})
    const service = new BookService()


    onMounted(async()=>{
    loading.value = true
    book.value = await service.GetBookDetail(route.params.id)
    loading.value = false
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: _unref(main).BOOK_SHOP_IMG,
              alt: "img prueba",
              width: `${widthIMG.value}`,
              height: `${heightIMG.value}`,
              style: {"border-radius":"8px"}
            }, null, 8, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", null, [
              _hoisted_7,
              _createElementVNode("p", null, _toDisplayString(book.value.title), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_8,
              _createElementVNode("p", null, _toDisplayString(book.value.author), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_9,
              _createElementVNode("p", null, _toDisplayString(book.value.category), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_10,
              _createElementVNode("p", null, _toDisplayString(book.value.publisher), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_11,
              _createElementVNode("p", null, _toDisplayString(book.value.updated_at?.slice(0,4)), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_12,
              _createElementVNode("p", null, _toDisplayString(book.value.description), 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_13, [
                (book.value.epub_uri != undefined && book.value.epub_uri.length > 3 )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("a", {
                        href: book.value.epub_uri,
                        download: ""
                      }, _hoisted_17, 8, _hoisted_15)
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_18,
                (book.value.pdf_uri != undefined && book.value.pdf_uri.length > 3 )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("a", {
                        href: book.value.pdf_uri,
                        download: ""
                      }, _hoisted_22, 8, _hoisted_20)
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_23,
                (book.value.paper_purchase_uri != undefined && book.value.paper_purchase_uri.length > 3 )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("a", {
                        href: book.value.paper_purchase_uri,
                        target: "_blank"
                      }, _hoisted_27, 8, _hoisted_25)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (book.value.paper_purchase_uri != undefined && book.value.paper_purchase_uri.length > 3 )
                ? (_openBlock(), _createElementBlock("p", _hoisted_28, "Al comprar el formato físico a través de este botón, estás contribuyendo al mantenimiento de esta comunidad, y a que siga siendo gratis para todos, para siempre. ¡Muchas gracias!"))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})